import SimpleStorage from 'wootils/esm/browser/simpleStorage';
/**
 * A small service to keep SSO data on the browser storage.
 * @extends {SimpleStorage}
 */
class SSOStorage extends SimpleStorage {
  /**
   * @param {FrontendConfiguration} appConfiguration To get the name of the storage key the service
   *                                                 will use.
   */
  constructor(appConfiguration) {
    'ngInject';

    super({
      storage: {
        name: 'sso',
        key: appConfiguration.storageKeys.sso,
      },
    });
  }
  /**
   * Deletes any saved user email address from the storage.
   */
  deleteUserEmailAddress() {
    const newData = Object.assign({}, this._getData());
    delete newData.emailAddress;
    this._setData(newData);
  }
  /**
   * Checks the storage and tries to retrieve the email address of the last user that used the
   * SSO.
   * @return {?string}
   */
  getUserEmailAddress() {
    return this._getData().emailAddress || null;
  }
  /**
   * Saves a user email address on the storage so it can be later retrieved for future logins.
   * The idea is for the SSO to be able to use the address to avoid asking the user to repeat the
   * whole process again.
   * @param {string} emailAddress The address to save.
   */
  saveUserEmailAddress(emailAddress) {
    const newData = Object.assign({}, this._getData(), { emailAddress });
    this._setData(newData);
  }
}

export default SSOStorage;
